export default "__VITE_ASSET__BTc$dZQR__"